import gql from 'graphql-tag';

export const getActivities = gql`
  query reservationEvent {
    eventsReservation {
      eventsSchedule {
        events {
          idEvent
          modality {
            description
            code
          }
          code
          service {
            serviceId
            name
          }
          date
          startTime
          endTime
          hasCrossing
          isRescheduled
          classroom
        }
      }
    }
  }
`;
